export default "__VITE_ASSET__DRf6tkau__"